import styled from "styled-components";
import { ScreenPlatform } from "@store/ducks/Screen/screen.type";

interface StylesheetProps {
  platform: ScreenPlatform;
}

export const Container = styled.div<StylesheetProps>`
  padding-top: 85px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-bottom: 64px;
  height: 100%;
  margin-top: ${(prop) => (prop.platform === "mobile" ? "5rem" : "0")};
`;

export const ContainerModal = styled.div`
  z-index: 2001;

  .MuiDialog-paper {
    width: 1200px;

    .mContent {

      .MuiTypography-root {
        width: 100%;
      }
      .MuiFormControl-root {
        width: 100%;

        .MuiFormHelperText-root {
          text-align: right;
          margin: 0;
        }
      }
    }
    .mFooter {
      justify-content: flex-end;
    }
  }
`;
